import { CurrencyValueProps } from '@blockanalitica/ui/package/types/src/components/molecules/CurrencyValue/CurrencyValue';
import { ComponentFactory } from '@blockanalitica/ui/package/types/src/theme/types';

export function currencyValue(): ComponentFactory<Partial<CurrencyValueProps>> {
  return {
    componentName: 'currencyValue',
    props: {
      options: {
        trendIconSize: '-1',
        currencySize: '0'
      }
    }
  };
}
